import React, { useState, useEffect } from "react";
import {
  TableComposable,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@patternfly/react-table";
import styles from "@patternfly/react-styles/css/components/Table/table";

const DragableTable = (props) => {
  const columns = props.columns;
  const rows = props.rows;

  const [draggedItemId, setDraggedItemId] = useState(null);
  const [draggingToItemIndex, setDraggingToItemIndex] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [itemOrder, setItemOrder] = useState([]);
  const [tempItemOrder, setTempItemOrder] = useState([]);

  const bodyRef = React.createRef();

  useEffect(() => {
    setItemOrder(props.rows.map((r) => r.id.toString()));
  }, [props.rows]);

  // function getIndex(id) {
  //   return Array.from(bodyRef.current.children).findIndex(
  //     (item) => item.id === id
  //   );
  // }

  function onDragStart(evt) {
    evt.dataTransfer.effectAllowed = "move";
    evt.dataTransfer.setData("text/plain", evt.currentTarget.id);
    const draggedItemId = evt.currentTarget.id;

    evt.currentTarget.classList.add(styles.modifiers.ghostRow);
    evt.currentTarget.setAttribute("aria-pressed", "true");
    setDraggedItemId(draggedItemId);
    setDragging(true);
  }

  function moveItem(arr, i1, toIndex) {
    const fromIndex = arr.indexOf(i1);
    if (fromIndex === toIndex) {
      return arr;
    }
    const temp = arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, temp[0]);

    return arr;
  }

  function move(itemOrder) {
    const ulNode = bodyRef.current;
    const nodes = Array.from(ulNode.children);
    if (nodes.map((node) => node.id).every((id, i) => id === itemOrder[i])) {
      return;
    }
    while (ulNode.firstChild) {
      ulNode.removeChild(ulNode.lastChild);
    }

    itemOrder.forEach((id) => {
      ulNode.appendChild(nodes.find((n) => n.id === id));
    });
  }

  function onDragCancel() {
    // move(itemOrder);
    Array.from(bodyRef.current.children).forEach((el) => {
      el.classList.remove(styles.modifiers.ghostRow);
      el.setAttribute("aria-pressed", "false");
    });
    setDraggedItemId(null);
    setDraggingToItemIndex(null);
    setDragging(false);
  }

  function onDragLeave(evt) {
    if (!isValidDrop(evt)) {
      move(itemOrder);
      setDraggingToItemIndex(null);
    }
  }

  function isValidDrop(evt) {
    const ulRect = bodyRef.current.getBoundingClientRect();
    return (
      evt.clientX > ulRect.x &&
      evt.clientX < ulRect.x + ulRect.width &&
      evt.clientY > ulRect.y &&
      evt.clientY < ulRect.y + ulRect.height
    );
  }

  function onDrop(evt) {
    if (isValidDrop(evt)) {
      setItemOrder(tempItemOrder);
      let newRows = tempItemOrder.map((item) => rows[parseInt(item) - 1]);
      props.handleDrag && props.handleDrag(newRows);
    } else {
      onDragCancel();
    }
  }

  function onDragOver(evt) {
    evt.preventDefault();

    const curListItem = evt.target.closest("tr");
    if (
      !curListItem ||
      !bodyRef.current.contains(curListItem) ||
      curListItem.id === draggedItemId
    ) {
      return null;
    } else {
      const dragId = curListItem.id;
      const newItemIndex = Array.from(bodyRef.current.children).findIndex(
        (item) => item.id === dragId
      );
      if (newItemIndex !== draggingToItemIndex) {
        const tempItemOrder = moveItem(
          [...itemOrder],
          draggedItemId,
          newItemIndex
        );
        move(tempItemOrder);

        setDraggingToItemIndex(newItemIndex);
        setTempItemOrder(tempItemOrder);
      }
    }
  }

  function onDragEnd(evt) {
    evt.target.classList.remove(styles.modifiers.ghostRow);
    evt.target.setAttribute("aria-pressed", "false");
    setDraggedItemId(null);
    setDraggingToItemIndex(null);
    setDragging(false);
  }

  return (
    <TableComposable
      aria-label="Draggable table"
      className={dragging && styles.modifiers.dragOver}
    >
      <Thead>
        <Tr>
          <Th />
          {columns.map((column, columnIndex) => (
            <Th key={columnIndex}>{column}</Th>
          ))}
        </Tr>
      </Thead>
      <Tbody
        ref={bodyRef}
        onDragOver={onDragOver}
        onDrop={onDrop}
        onDragLeave={onDragLeave}
      >
        {rows.map((row, rowIndex) => (
          <Tr
            key={rowIndex}
            id={row.id}
            draggable
            onDrop={onDrop}
            onDragEnd={onDragEnd}
            onDragStart={onDragStart}
          >
            <Td
              draggableRow={{
                id: `draggable-row-${row.id}`,
              }}
            />
            {Object.keys(row).map((key, keyIndex) => (
              <Td key={`${rowIndex}_${keyIndex}`} dataLabel={columns[keyIndex]}>
                {row[key]}
              </Td>
            ))}
          </Tr>
        ))}
      </Tbody>
    </TableComposable>
  );
};

export default DragableTable;
